var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"partner-container"}},_vm._l((_vm.pArray),function(partner){return _c('img',{key:partner.id,staticClass:"partners-logo",attrs:{"src":(_vm.API + "/partners/images/" + (partner.image)),"alt":partner.name}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }